/* eslint-disable react/display-name */
import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Tabs, Input} from 'antd';

import {ApartmentOutlined, TagsOutlined, TagOutlined, TeamOutlined, UserOutlined} from '@/icons';
import DepartTabPane from './tabPane/DepartTabPane';
import UserTabPane from './tabPane/UserTabPane';
import TagTabPane from './tabPane/TagTabPane';
import AppAllowUserTabPane from './tabPane/AppAllowUserTabPane';
import AppTagTabPane from './tabPane/AppTagTabPane';

import styles from './MainPanel.module.less';

const TABS = {
    departTab: {
        key: 'departTab',
        tab: '部门',
        icon: <ApartmentOutlined />,
        component: DepartTabPane,
    },

    userTab: {key: 'userTab', tab: '员工', icon: <TeamOutlined />, component: UserTabPane},

    // 只在应用发送消息时可用
    allowUserTab: {
        key: 'allowUserTab',
        tab: '可见员工',
        icon: <UserOutlined />,
        component: AppAllowUserTabPane,
    },

    tagTab: {key: 'tagTab', tab: '企微标签', icon: <TagsOutlined />, component: TagTabPane},
    // appTagTab: {
    //     key: 'appTagTab',
    //     tab: 'AD 应用标签',
    //     icon: <TagOutlined />,
    //     component: props => <AppTagTabPane adType={1} {...props} />,
    // },
    // adTagTab: {
    //     key: 'adTagTab',
    //     tab: 'AD 标签',
    //     icon: <TagOutlined />,
    //     component: props => <AppTagTabPane adType={2} {...props} />,
    // },
};

export default function MainPanel({
    selectedValues,
    showDepartTab = true,
    showUserTab = true,
    showTagTab = true,
    showAppTagTab = false,
    showAdTagTab = false,
    allowDepartIds,
    allowUsers,
    onAddSelected,
    onReplaceSelectedByType,
}) {
    const tabs = [];
    if (showDepartTab) {
        tabs.push(TABS.departTab);
    }
    if (showUserTab) {
        tabs.push(TABS.userTab);
    }
    if (Array.isArray(allowUsers) && allowUsers.length > 0) {
        tabs.push(TABS.allowUserTab);
    }
    if (showTagTab) {
        tabs.push(TABS.tagTab);
    }
    if (showAppTagTab) {
        tabs.push(TABS.appTagTab);
    }
    if (showAdTagTab) {
        tabs.push(TABS.adTagTab);
    }

    console.log(
        '...',
        tabs,
        // showDepartTab,
        // showUserTab,
        // allowUsers,
        // showTagTab,
        showAppTagTab,
        // showAdTagTab
    );

    const [activeKey, setActiveKey] = useState(tabs[0].key);

    // 用于记录输入时查询框的值
    const [searchValue, setSearchValue] = useState(null);
    // 用于记录查询框最终值，之所以分为 2 个，是为了防止输入时候随时查询
    const [finalSearchValue, setFinalSearchValue] = useState(null);

    function onTabChange(key) {
        setActiveKey(key);
        setSearchValue(null);
        setFinalSearchValue(null);
    }

    function onSearchChange(e) {
        setSearchValue(e.target.value);
    }

    function onSearch(value) {
        setFinalSearchValue(value);
    }

    function clearSearchValue() {
        setSearchValue(null);
        setFinalSearchValue(null);
    }

    function getExtraProps(key) {
        if (key === 'departTab') {
            return {allowDepartIds};
        }
        if (key === 'userTab') {
            return {allowDepartIds, searchValue: finalSearchValue, clearSearchValue};
        }
        if (key === 'allowUserTab') {
            return {allowUsers};
        }
        if (key === 'tagTab') {
            return {searchValue: finalSearchValue, clearSearchValue};
        }
        return {};
    }

    function renderSearch() {
        let placeholder = '查询';
        if (activeKey === 'userTab') {
            placeholder = '按姓名、员工编号查询';
        } else if (activeKey === 'tagTab') {
            placeholder = '按标签名查询';
        }
        return (
            <Input.Search
                allowClear
                style={{width: 300}}
                placeholder={placeholder}
                value={searchValue}
                onChange={onSearchChange}
                onSearch={onSearch}
            />
        );
    }

    const extra = ['userTab', 'tagTab'].includes(activeKey) ? renderSearch() : null;

    return (
        <Tabs tabBarExtraContent={extra} activeKey={activeKey} onChange={onTabChange}>
            {tabs.map(({key, tab, icon, component: Comp}) => (
                <Tabs.TabPane
                    key={key}
                    tab={
                        <>
                            {icon}
                            {tab}
                        </>
                    }
                >
                    <div className={styles.tabPane}>
                        <Comp
                            selectedValues={selectedValues}
                            onAddSelected={onAddSelected}
                            onReplaceSelectedByType={onReplaceSelectedByType}
                            {...getExtraProps(key)}
                        />
                    </div>
                </Tabs.TabPane>
            ))}
        </Tabs>
    );
}

MainPanel.propTypes = {
    selectedValues: PropTypes.object,

    /**
     * 是否显示部门选择 tab
     */
    showDepartTab: PropTypes.bool,

    /**
     * 是否显示人员选择 tab
     */
    showUserTab: PropTypes.bool,

    /**
     * 是否显示标签选择 tab
     */
    showTagTab: PropTypes.bool,

    /**
     * 是否显示应用标签 tab，默认为 false
     */
    showAppTagTab: PropTypes.bool,

    /**
     * 是否显示 AD 非应用标签 tab
     */
    showAdTagTab: PropTypes.bool,

    /**
     * 可见的部门 id
     *
     * 如果为为 null 或 undefined, 表示所有部门可见
     *
     * 如果是 [] ，表示所有不可见
     * 如果有值，则对应部门和子部门可见
     */
    allowDepartIds: PropTypes.arrayOf(PropTypes.string),

    allowUsers: PropTypes.array,

    onAddSelected: PropTypes.func.isRequired,
    onReplaceSelectedByType: PropTypes.func.isRequired,
};
